var _clipPath, _clipPath2, _clipPath3, _clipPath4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 127.77707 102.36756",
    xmlSpace: "preserve",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    id: "svg144",
    sodipodiDocname: "logo-header-dark.svg",
    inkscapeVersion: "1.1 (c68e22c387, 2021-05-23)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.12102682,0,0,0.1193291,-2565.2923,-136.17625)",
    id: "g120"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,20533.6,0)",
    id: "g118"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.5967,-16.4558)",
    id: "g116"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-4928.07,0)",
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 21651.3,1593.15 1,-0.6 v -39.91 c 0,0 14.1,-3.75 14.1,-3.75 v -15.02 l -53.1,1.01 v 14.06 l 16,3.75 c 0,0 0,27.73 0,27.73 -3.6,1.16 -14,4.12 -24.3,4.12 -11.5,0 -21.4,-3.73 -28.3,-11.53 -7,-7.93 -11,-19.96 -11,-36.27 0,-20.16 4.8,-34.81 14,-43.26 6,-5.51 13.9,-8.31 23.5,-8.31 11.2,0 20.6,2.45 23.7,3.34 0,0 5.7,21.14 5.7,21.14 h 15.9 l 1,-34.51 -1.3,-0.56 c 0,0 -22,-9.57 -43.2,-9.57 -19.9,0 -36.2,7.1 -47.5,19.75 -11.3,12.57 -17.6,30.68 -17.6,52.92 0,21.83 5.9,38.53 16.6,49.8 10.7,11.32 26.2,17.24 45.7,17.24 28.7,0 49.1,-11.57 49.1,-11.57 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-4154.57,214.964)",
    id: "g8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 18724.2,637.296 c 0,-20.828 -5.7,-37.756 -16,-49.5 -10.3,-11.835 -25.4,-18.475 -44.5,-18.475 -19.5,0 -35.3,7.104 -46.2,19.529 -10.9,12.337 -17,29.978 -17,51.271 0,22.256 5.4,39.405 15.4,51.017 10.1,11.723 25,17.9 44.1,17.9 37.8,0 64.2,-29.024 64.2,-71.742 z m -97.9,1.875 c 0,-20.657 4.7,-34.526 13.7,-42.268 5.9,-5.057 13.6,-7.419 22.8,-7.419 9.2,0 16.7,2.501 22.4,7.603 8.8,7.827 13.2,21.579 13.2,41.138 0,20.672 -5.1,34.876 -14.4,42.885 -6,5.232 -13.8,7.749 -23.1,7.749 -9.2,0 -16.5,-2.632 -22,-7.887 -8.5,-8.1 -12.6,-22.198 -12.6,-41.801 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-4928.07,0)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 21805,1532.98 c 0,-20.83 -5.7,-37.76 -16,-49.5 -10.3,-11.83 -25.4,-18.47 -44.5,-18.47 -19.5,0 -35.3,7.1 -46.2,19.52 -10.9,12.34 -17,29.98 -17,51.28 0,22.25 5.4,39.4 15.4,51.01 10.1,11.73 25,17.9 44.1,17.9 37.8,0 64.2,-29.02 64.2,-71.74 z m -97.9,1.88 c 0,-20.66 4.7,-34.53 13.7,-42.27 5.9,-5.06 13.6,-7.42 22.8,-7.42 9.2,0 16.7,2.5 22.4,7.6 8.8,7.83 13.2,21.58 13.2,41.14 0,20.67 -5.1,34.88 -14.4,42.89 -6,5.23 -13.9,7.74 -23.1,7.74 -9.2,0 -16.5,-2.63 -22,-7.88 -8.5,-8.1 -12.6,-22.2 -12.6,-41.8 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path10"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-4154.57,214.964)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 18744.2,691.733 -1.6,0.378 v 15.034 h 58.6 c 19.4,0 35.5,-6.858 46.7,-19.026 11.1,-12.106 17.5,-29.518 17.5,-50.824 0,-21.344 -5.9,-37.811 -16.5,-48.969 -10.6,-11.21 -25.9,-17.127 -44.9,-17.127 h -23.6 c 0,0.001 -37.8,0.996 -37.8,0.996 v 14.037 l 16,3.771 c 0,0 0,98.354 0,98.354 0,0 -14.4,3.376 -14.4,3.376 z m 57.9,-3.809 h -19.6 c 0,0 0,-97.487 0,-97.487 0,0 20.5,0 20.5,0 8.9,0 16.5,2.226 22.5,7.057 9,7.373 14,20.665 14,40.73 0,20.65 -5.3,34.514 -14.7,42.255 -6.1,5.064 -13.8,7.445 -22.7,7.445 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path14"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-4928.07,0)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 21563.3,1768.81 -3.9,-20.5 h -18.9 v 36.42 l 1.3,0.54 c 0,0 19.4,8.07 39.6,7.88 v 0 c 27.6,-0.6 51.8,-14.02 51.2,-43.54 -0.3,-22.19 -17.7,-30.67 -35.3,-37.1 -8.2,-3.03 -16.5,-5.62 -22.8,-9.22 -5.6,-3.27 -9.5,-7.36 -9.7,-13.74 v 0 c -0.1,-8.53 7.7,-15.97 23,-16.15 v 0 c 8.1,-0.14 15.7,2.09 18.3,2.94 0,0 6.5,20.61 6.5,20.61 h 15.8 l 1,-35.54 -1.4,-0.51 c 0,0 -22.2,-8.04 -40.4,-7.65 -24.7,0.39 -47.1,11.9 -46.7,39.58 v 0 c 0.4,23.83 17.8,32.65 35.4,39.1 8.3,3.04 16.6,5.55 22.9,9.11 5.6,3.21 9.5,7.27 9.7,13.72 0,5.9 -3.4,10.25 -8.2,13.2 -5.2,3.16 -12.1,4.74 -18.6,4.83 v 0 c -9.5,0.29 -16.5,-2.82 -18.8,-3.98 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-4928.07,0)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 21634.9,1775.67 -1.6,0.37 v 15.03 h 56 V 1776 l -17.1,-3.44 c 0,0 6.1,-17.26 6.1,-17.26 0,0 46,0 46,0 0,0 5.9,17.26 5.9,17.26 0,0 -16.9,3.44 -16.9,3.44 v 15.07 h 58.8 v -15.03 l -16.1,-3.69 c 0,0 -42,-117.3 -42,-117.3 l -21.7,1.09 -43,116.21 c 0,0 -14.4,3.32 -14.4,3.32 z m 49.9,-39.59 16.8,-48.15 c 0,0 16.2,48.15 16.2,48.15 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path22"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-4928.07,0)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 21776.4,1791.07 h 55.9 v -15.02 l -16,-3.77 c 0,0 0,-98.36 0,-98.36 0,0 16,-3.77 16,-3.77 v -15.06 l -55.9,1.02 v 14.04 l 16,3.77 c 0,0 0,98.36 0,98.36 0,0 -16,3.77 -16,3.77 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path26"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0883349,0,0,0.0883349,-1423.05,372.47)",
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 18151.8,1191.53 h -29.9 l 5.8,-4.82 v 75.84 l -4.5,-5.46 39.9,6.42 v 13.82 h -89.4 v -13.82 l 32.5,-6.74 -4.8,5.78 v -194.41 l 5.4,6.1 -33.1,-5.78 v -13.82 l 54.7,-1.61 h 36.3 c 16.5,0 30.1,2.79 40.8,8.36 10.7,5.57 18.7,13.28 24.1,23.14 5.3,9.85 8,21.31 8,34.38 0,14.35 -3.2,26.99 -9.6,37.92 -6.5,10.92 -16,19.44 -28.8,25.54 -12.7,6.11 -28.5,9.16 -47.4,9.16 z m 9,-118.89 h -37.9 l 4.8,-4.82 v 108.93 l -5.8,-4.82 h 29.9 c 18.9,0 33.4,-4.71 43.6,-14.14 10.1,-9.42 15.2,-22.17 15.2,-38.24 0,-14.57 -4.2,-26.03 -12.7,-34.38 -8.4,-8.36 -20.8,-12.53 -37.1,-12.53 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18338.5,1104.77 c 23.6,0 42.1,7.39 55.4,22.17 13.4,14.78 20.1,35.67 20.1,62.66 0,18.21 -3.2,34.12 -9.8,47.72 -6.5,13.61 -15.8,24.16 -27.8,31.66 -12,7.49 -26.4,11.24 -43.3,11.24 -23.2,0 -41.3,-7.23 -54.4,-21.69 -13,-14.46 -19.6,-35.29 -19.6,-62.5 0,-18.85 3.2,-35.08 9.5,-48.68 6.3,-13.61 15.4,-24.1 27.3,-31.49 11.9,-7.39 26.1,-11.09 42.6,-11.09 z m -1.3,18.96 c -16.5,0 -29.1,6.21 -37.9,18.64 -8.8,12.42 -13.2,29.88 -13.2,52.38 0,22.06 4.2,38.66 12.6,49.8 8.3,11.14 20.3,16.71 36,16.71 11.3,0 20.9,-2.84 28.7,-8.51 7.8,-5.68 13.7,-13.77 17.7,-24.26 4,-10.5 5.9,-23.03 5.9,-37.6 0,-21.85 -4.3,-38.51 -13,-49.97 -8.7,-11.46 -20.9,-17.19 -36.8,-17.19 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18616.2,1108.63 64.5,-2.25 v 14.14 l -22.4,5.46 4.5,-3.86 -44.1,155.85 h -28.3 l -41.7,-151.67 h 5.1 l -44.3,151.67 h -28.3 l -42.1,-155.2 3.9,3.85 -22.2,-4.18 v -13.81 l 69.4,-2.25 v 14.14 l -29.3,5.14 2.9,-3.22 35.7,139.79 h -4.2 l 43.1,-153.92 27.9,-1.93 41.5,156.81 h -4.2 l 37.6,-140.1 2.9,3.53 -27.9,-4.18 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18761.4,1280.22 c -14.4,0 -27,-3.26 -38.1,-9.8 -11,-6.53 -19.6,-16.12 -25.8,-28.76 -6.3,-12.64 -9.4,-28.06 -9.4,-46.27 0,-18.64 3.3,-34.71 9.7,-48.2 6.4,-13.5 15.5,-23.94 27.3,-31.33 11.8,-7.39 25.6,-11.09 41.4,-11.09 15,0 27.4,3.16 37.2,9.48 9.7,6.32 17,15.05 21.8,26.19 4.8,11.14 7.2,23.89 7.2,38.24 0,2.36 -0.1,4.71 -0.3,7.07 -0.2,2.36 -0.5,5.25 -0.9,8.67 h -123.8 v -18.31 h 101.3 l -2.9,1.93 c 0.2,-9.64 -1,-18.53 -3.6,-26.67 -2.5,-8.15 -6.9,-14.68 -13.1,-19.61 -6.3,-4.92 -14.5,-7.39 -24.8,-7.39 -10.9,0 -20.1,2.89 -27.6,8.68 -7.5,5.78 -13.1,13.71 -16.7,23.78 -3.7,10.07 -5.5,21.74 -5.5,35.02 0,14.14 2,26.3 6.1,36.48 4.1,10.17 10,18.05 17.8,23.61 7.9,5.57 17.5,8.36 28.8,8.36 7.9,0 16.6,-1.55 26,-4.66 9.5,-3.11 19.2,-7.87 29.3,-14.3 l 9.3,14.46 c -12,8.14 -24,14.25 -36,18.32 -12,4.07 -23.6,6.1 -34.7,6.1 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18860.7,1277.33 v -13.82 l 28.3,-6.1 -3.2,4.82 v -138.5 l 3.5,4.82 -28.6,-6.11 v -13.81 l 45,-2.25 3.5,31.49 -3.5,-1.29 c 9.6,-10.07 19.1,-17.89 28.3,-23.46 9.2,-5.56 19.2,-8.35 30.2,-8.35 6.8,0 14,1.07 21.5,3.21 l -1.9,46.92 h -16.1 l -3.9,-33.74 2.9,5.78 c -1.5,-0.43 -3.1,-0.75 -4.8,-0.96 -1.7,-0.21 -3.4,-0.32 -5.1,-0.32 -8.6,0 -16.9,2.57 -24.9,7.71 -8.1,5.14 -15.7,11.78 -23,19.92 l 2.6,-7.71 v 116.65 l -3.9,-4.82 35,6.1 v 13.82 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19071.8,1280.22 c -14.3,0 -27,-3.26 -38.1,-9.8 -11,-6.53 -19.6,-16.12 -25.8,-28.76 -6.2,-12.64 -9.3,-28.06 -9.3,-46.27 0,-18.64 3.2,-34.71 9.6,-48.2 6.4,-13.5 15.5,-23.94 27.3,-31.33 11.8,-7.39 25.6,-11.09 41.5,-11.09 15,0 27.3,3.16 37.1,9.48 9.7,6.32 17,15.05 21.8,26.19 4.8,11.14 7.3,23.89 7.3,38.24 0,2.36 -0.2,4.71 -0.4,7.07 -0.2,2.36 -0.5,5.25 -0.9,8.67 h -123.7 v -18.31 h 101.2 l -2.9,1.93 c 0.2,-9.64 -1,-18.53 -3.5,-26.67 -2.6,-8.15 -7,-14.68 -13.2,-19.61 -6.2,-4.92 -14.5,-7.39 -24.8,-7.39 -10.9,0 -20.1,2.89 -27.6,8.68 -7.5,5.78 -13.1,13.71 -16.7,23.78 -3.7,10.07 -5.5,21.74 -5.5,35.02 0,14.14 2.1,26.3 6.1,36.48 4.1,10.17 10,18.05 17.9,23.61 7.8,5.57 17.4,8.36 28.7,8.36 8,0 16.6,-1.55 26.1,-4.66 9.4,-3.11 19.1,-7.87 29.2,-14.3 l 9.3,14.46 c -12,8.14 -24,14.25 -36,18.32 -12,4.07 -23.5,6.1 -34.7,6.1 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19237.6,1280.22 c -11.8,0 -22.5,-3.26 -32.1,-9.8 -9.6,-6.53 -17.2,-16.17 -22.8,-28.92 -5.6,-12.75 -8.4,-28.22 -8.4,-46.43 0,-29.78 7.6,-52.27 22.8,-67.48 15.3,-15.21 36.1,-22.82 62.7,-22.82 5.6,0 11.4,0.43 17.5,1.29 6.1,0.85 12.4,2.14 18.8,3.85 l -5.1,2.89 v -64.59 l 2.9,3.54 -29.6,-6.43 v -13.82 l 52.4,-2.24 v 232.33 l -3.9,-4.5 28.9,5.78 v 14.14 l -44.9,1.93 -3.9,-27.64 3.2,1.29 c -9.6,9.21 -19.3,16.12 -29.1,20.72 -9.7,4.61 -19.5,6.91 -29.4,6.91 z m 9,-19.6 c 7.5,0 15.3,-1.98 23.3,-5.94 8.1,-3.97 16.1,-9.91 24.3,-17.84 l -3.2,8.68 v -121.79 l 3.5,6.43 c -13.1,-4.29 -25,-6.43 -35.7,-6.43 -18.8,0 -33.2,6.11 -43,18.32 -9.9,12.21 -14.8,29.13 -14.8,50.77 0,14.14 2,26.29 5.9,36.47 4,10.18 9.5,17.94 16.4,23.3 7,5.35 14.8,8.03 23.3,8.03 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19494.1,1280.22 c -7.8,0 -15.9,-0.53 -24.6,-1.6 -8.7,-1.07 -17.9,-2.68 -27.5,-4.82 v -229.44 l 5.1,7.39 -30.2,-6.43 v -13.82 l 50.8,-2.24 v 105.72 l -3.5,-3.86 c 9,-8.57 18.3,-15.1 27.9,-19.6 9.7,-4.5 19.3,-6.75 29,-6.75 11.9,0 22.7,3.32 32.2,9.96 9.6,6.64 17.1,16.28 22.7,28.92 5.6,12.64 8.4,28.17 8.4,46.6 0,13.92 -1.8,26.45 -5.3,37.59 -3.6,11.14 -9,20.57 -16.3,28.28 -7.3,7.71 -16.6,13.66 -27.9,17.84 -11.4,4.17 -25,6.26 -40.8,6.26 z m 4.8,-18.96 c 19,0 33.6,-5.89 43.7,-17.67 10.1,-11.78 15.1,-28.92 15.1,-51.42 0,-14.13 -2,-26.24 -6,-36.31 -3.9,-10.06 -9.3,-17.83 -16.2,-23.29 -6.8,-5.47 -14.7,-8.2 -23.4,-8.2 -7.5,0 -15.3,1.98 -23.3,5.95 -8.1,3.96 -16.2,10.01 -24.3,18.15 l 3.2,-9.32 v 124.04 l -3.5,-7.07 c 13,3.43 24.6,5.14 34.7,5.14 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19598.2,1352.52 2.2,-18.95 c 2.6,0.42 5,0.75 7.3,0.96 2.2,0.21 4.3,0.32 6.2,0.32 10.5,0 19,-2.41 25.6,-7.23 6.5,-4.82 12,-12.05 16.5,-21.69 4.5,-9.64 9.1,-21.64 13.8,-35.99 l -0.9,9.64 -60.1,-156.49 3.5,2.89 -20.9,-3.54 v -13.81 l 70.4,-2.25 v 14.14 l -28.9,4.82 1.9,-2.9 47.9,136.57 -5.8,-1.28 46,-134.64 1.9,2.89 -28.3,-3.54 v -13.81 l 68.1,-2.25 v 14.14 l -22.5,5.14 4.5,-2.89 -56.5,155.2 c -3.9,10.71 -7.9,20.68 -12.1,29.89 -4.1,9.21 -8.9,17.3 -14.3,24.26 -5.3,6.96 -11.9,12.37 -19.6,16.23 -7.7,3.85 -17,5.78 -27.9,5.78 -5,0 -11,-0.53 -18,-1.61 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19925.3,1066.85 -31.5,7.07 3.5,-4.5 v 192.17 l -3.5,-4.5 31.5,6.42 v 13.82 h -81.9 v -13.82 l 31.1,-6.42 -3.5,4.5 v -192.17 l 4.2,4.82 -31.8,-5.78 v -13.82 l 81.9,-1.61 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19952.9,1277.33 v -13.82 l 29,-6.42 -3.9,4.82 v -138.18 l 3.9,4.82 -29,-6.11 v -13.81 l 45,-2.25 3.6,31.49 -3.6,-1.29 c 10.7,-10.92 21.9,-18.96 33.6,-24.1 11.7,-5.14 22.8,-7.71 33.3,-7.71 14.1,0 25.8,4.34 35.1,13.02 9.4,8.67 13.9,22.11 13.7,40.32 v 103.8 l -3.2,-4.5 28.3,6.1 v 13.82 h -74.9 v -13.82 l 28,-6.1 -3.9,4.82 v -98.65 c 0,-13.29 -3,-23.03 -9,-29.25 -6,-6.21 -14,-9.31 -24.1,-9.31 -7.9,0 -16.5,2.14 -25.9,6.42 -9.3,4.29 -18.4,10.93 -27.4,19.93 l 2.2,-5.15 v 116.01 l -3.2,-4.5 27.3,5.78 v 13.82 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20156.3,1277.33 v -13.82 l 29,-6.42 -3.9,4.82 v -138.18 l 3.9,4.82 -29,-6.11 v -13.81 l 45,-2.25 3.6,31.49 -3.6,-1.29 c 10.7,-10.92 21.9,-18.96 33.6,-24.1 11.7,-5.14 22.8,-7.71 33.3,-7.71 14.1,0 25.8,4.34 35.2,13.02 9.3,8.67 13.8,22.11 13.6,40.32 v 103.8 l -3.2,-4.5 28.3,6.1 v 13.82 h -74.9 v -13.82 l 28,-6.1 -3.9,4.82 v -98.65 c 0,-13.29 -3,-23.03 -9,-29.25 -6,-6.21 -14,-9.31 -24.1,-9.31 -7.9,0 -16.5,2.14 -25.9,6.42 -9.3,4.29 -18.4,10.93 -27.4,19.93 l 2.2,-5.15 v 116.01 l -3.2,-4.5 27.3,5.78 v 13.82 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20442,1104.77 c 23.6,0 42.1,7.39 55.4,22.17 13.4,14.78 20.1,35.67 20.1,62.66 0,18.21 -3.2,34.12 -9.8,47.72 -6.5,13.61 -15.8,24.16 -27.8,31.66 -12,7.49 -26.4,11.24 -43.3,11.24 -23.2,0 -41.3,-7.23 -54.4,-21.69 -13,-14.46 -19.6,-35.29 -19.6,-62.5 0,-18.85 3.2,-35.08 9.5,-48.68 6.3,-13.61 15.4,-24.1 27.3,-31.49 11.9,-7.39 26.1,-11.09 42.6,-11.09 z m -1.3,18.96 c -16.5,0 -29.1,6.21 -37.9,18.64 -8.8,12.42 -13.2,29.88 -13.2,52.38 0,22.06 4.2,38.66 12.6,49.8 8.3,11.14 20.3,16.71 36,16.71 11.3,0 20.9,-2.84 28.7,-8.51 7.8,-5.68 13.7,-13.77 17.7,-24.26 4,-10.5 5.9,-23.03 5.9,-37.6 0,-21.85 -4.3,-38.51 -13,-49.97 -8.7,-11.46 -20.9,-17.19 -36.8,-17.19 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20629.4,1108.63 67.1,-2.25 v 14.14 l -21.8,6.42 4.5,-4.82 -55.9,155.85 h -30.3 l -51,-155.2 4.5,4.17 -22.2,-4.5 v -13.81 l 70.7,-2.25 v 14.14 l -29.3,5.46 2.6,-3.86 43.1,139.47 h -2.6 l 46.6,-138.5 1.9,2.89 -27.9,-3.54 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20756,1260.94 -2.9,-3.53 27.9,6.1 v 13.82 h -75.8 v -13.82 l 28,-6.1 -2.9,3.53 v -135.6 l 2.5,2.89 -27.6,-5.79 v -13.81 l 50.8,-1.93 z m -14.8,-188.95 c -4.9,0 -9,-1.6 -12.2,-4.82 -3.2,-3.21 -4.8,-7.6 -4.8,-13.17 0,-5.79 1.6,-10.23 4.9,-13.34 3.4,-3.1 7.5,-4.66 12.4,-4.66 5.1,0 9.3,1.5 12.5,4.5 3.3,3 4.9,7.5 4.9,13.5 0,5.78 -1.8,10.23 -5.2,13.33 -3.4,3.11 -7.6,4.66 -12.5,4.66 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20833.4,1148.79 c 0,6.86 2.3,12.22 6.8,16.07 4.5,3.86 10.2,7.02 17.3,9.48 7.1,2.46 14.6,4.87 22.5,7.23 7.9,2.36 15.4,5.25 22.5,8.68 7.1,3.42 12.9,8.14 17.4,14.14 4.5,5.99 6.7,13.92 6.7,23.77 0,11.36 -3.1,20.89 -9.3,28.61 -6.2,7.71 -14.6,13.54 -25.2,17.51 -10.6,3.96 -22.5,5.94 -35.6,5.94 -7.9,0 -16,-0.64 -24.4,-1.93 -8.3,-1.28 -16.9,-3.1 -25.7,-5.46 l 2.3,-43.06 h 16.4 l 3.2,31.49 -2.9,-3.53 c 4.9,1.28 10.3,2.36 16,3.21 5.8,0.86 11.2,1.29 16.1,1.29 7.7,0 14.8,-1.13 21.4,-3.38 6.5,-2.25 11.8,-5.57 15.9,-9.96 4.1,-4.39 6.1,-9.91 6.1,-16.55 0,-7.07 -2.2,-12.64 -6.6,-16.71 -4.4,-4.07 -10.1,-7.39 -17.2,-9.96 -7.1,-2.57 -14.5,-4.98 -22.3,-7.23 -7.8,-2.25 -15.3,-5.14 -22.4,-8.67 -7,-3.54 -12.8,-8.2 -17.3,-13.98 -4.5,-5.79 -6.8,-13.71 -6.8,-23.78 0,-10.93 2.9,-19.87 8.6,-26.84 5.6,-6.96 13.1,-12.1 22.5,-15.42 9.3,-3.32 19.3,-4.98 30,-4.98 7.3,0 15.3,0.75 24.1,2.25 8.8,1.5 17.8,3.75 27,6.75 l -1.6,36.31 h -16.4 l -4.8,-26.67 3.8,4.5 c -11.1,-3.22 -21.6,-4.82 -31.5,-4.82 -10.5,0 -19.2,2.19 -26.1,6.58 -7,4.4 -10.5,10.77 -10.5,19.12 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path60"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-4154.57,214.964)",
    id: "g66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 18659.3,876.163 v -97.926 c 0,0 16,-3.771 16,-3.771 v -15.067 l -55.9,1.022 v 14.045 l 16,3.771 c 0,0 0,98.359 0,98.359 0,0 -16,3.767 -16,3.767 v 15.024 h 95.4 v -40.875 h -17 l -3.7,21.65 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path64"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-4124.96,260.142)",
    id: "g70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 18724.2,637.296 c 0,-20.828 -5.7,-37.756 -16,-49.5 -10.3,-11.835 -25.4,-18.475 -44.5,-18.475 -19.5,0 -35.3,7.104 -46.2,19.529 -10.9,12.337 -17,29.978 -17,51.271 0,22.256 5.4,39.405 15.4,51.017 10.1,11.723 25,17.9 44.1,17.9 37.8,0 64.2,-29.024 64.2,-71.742 z m -97.9,1.875 c 0,-20.657 4.7,-34.526 13.7,-42.268 5.9,-5.057 13.6,-7.419 22.8,-7.419 9.2,0 16.7,2.501 22.4,7.603 8.8,7.827 13.2,21.579 13.2,41.138 0,20.672 -5.1,34.876 -14.4,42.885 -6,5.232 -13.8,7.749 -23.1,7.749 -9.2,0 -16.5,-2.632 -22,-7.887 -8.5,-8.1 -12.6,-22.198 -12.6,-41.801 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path68"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-4928.07,0)",
    id: "g74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 22086.7,1775.67 -1.6,0.38 v 15.02 h 55.9 v -15.02 l -16,-3.77 c 0,0 0,-38.63 0,-38.63 0,0 6.4,0 6.4,0 4.5,0 7.8,0.48 10.7,2.23 4.5,2.75 7.8,8.42 12.8,19.16 0,0 16.6,36.03 16.6,36.03 h 31.7 v -15.03 l -14.1,-3.17 c 0,0 -14.4,-29.06 -14.4,-29.06 -3.9,-7.51 -6.9,-12.21 -9.5,-15.24 15.1,-6.71 22.9,-19.36 22.9,-37.48 0,-8.98 -2.7,-16.54 -7.8,-22.39 -7.4,-8.63 -20,-13.58 -36.6,-13.58 h -20.8 c 0,0 -37.8,1.01 -37.8,1.01 v 14.02 l 16,3.77 c 0,0 0,98.36 0,98.36 0,0 -14.4,3.39 -14.4,3.39 z m 38.3,-60.29 v -41.03 c 0,0 17.7,0 17.7,0 12.5,0 21.5,8.12 21.5,19.57 0,5.4 -1.6,9.91 -4.5,13.36 -4.5,5.32 -12.3,8.1 -22.6,8.1 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path72"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24,0,0,0.24,-4928.07,0)",
    id: "g78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 22235.9,1768.81 -3.9,-20.5 h -18.9 v 36.42 l 1.3,0.54 c 0,0 19.4,8.07 39.6,7.88 v 0 c 27.6,-0.6 51.8,-14.02 51.2,-43.54 -0.3,-22.19 -17.7,-30.67 -35.3,-37.1 -8.3,-3.03 -16.5,-5.62 -22.8,-9.22 -5.6,-3.27 -9.6,-7.36 -9.7,-13.74 v 0 c -0.2,-8.53 7.6,-15.97 23,-16.15 v 0 c 8.1,-0.14 15.7,2.09 18.2,2.94 0,0 6.6,20.61 6.6,20.61 h 15.8 l 1,-35.54 -1.4,-0.51 c 0,0 -22.2,-8.04 -40.5,-7.65 -24.7,0.39 -47,11.9 -46.6,39.58 v 0 c 0.4,23.83 17.8,32.65 35.4,39.1 8.3,3.04 16.6,5.55 22.8,9.11 5.7,3.21 9.6,7.27 9.7,13.72 0.1,5.9 -3.3,10.25 -8.1,13.2 -5.2,3.16 -12.1,4.74 -18.6,4.83 v 0 c -9.5,0.29 -16.5,-2.82 -18.8,-3.98 z",
    style: {
      fill: "#005881",
      fillRule: "nonzero"
    },
    id: "path76"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(46.4619,0,0,-46.4619,175.461,648.161)",
    id: "g87"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.024,5.897 C 0.02,5.821 0.008,5.528 0,5.354 0.012,5.623 1.011,5.51 1,5.804 0.995,5.944 0.987,6.067 0.978,6.305 0.97,6.111 0.038,6.185 0.024,5.897 Z",
    clipRule: "nonzero",
    id: "path80"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)",
    id: "g85"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -11.655,
    y: -3.4890001,
    width: 18.101,
    height: 12.806,
    style: {
      fill: "url(#_Linear2)"
    },
    id: "rect83"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.4033,0,0,-50.4033,173.492,613.142)",
    id: "g96"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.018,4.013 C 0.009,3.891 0.005,3.772 0,3.664 0,3.543 1.007,3.521 1,3.664 0.994,3.793 0.978,4.207 0.966,4.403 0.979,4.152 0.034,4.258 0.018,4.013 Z",
    clipRule: "nonzero",
    id: "path89"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)",
    id: "g94"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10.705,
    y: -3.9100001,
    width: 16.684999,
    height: 11.805,
    style: {
      fill: "url(#_Linear4)"
    },
    id: "rect92"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(43.0185,0,0,-43.0185,177.186,684.609)",
    id: "g105"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.102,8.353 V 8.243 C 0.052,8.236 0.029,8.2 0.026,8.119 0.023,8.043 0.009,7.677 0,7.506 0.043,7.789 1.012,7.643 1,7.943 0.992,8.143 0.991,8.066 0.988,8.129 0.985,8.19 0.972,8.241 0.917,8.244 v 0.109 c 0,0.079 -0.21,0.122 -0.408,0.122 -0.197,0 -0.407,-0.043 -0.407,-0.122 z m 0.42,-0.031 v 0.126 c 0.047,0 0.09,-0.003 0.129,-0.007 V 8.314 C 0.615,8.318 0.572,8.321 0.522,8.322 Z M 0.367,8.441 C 0.406,8.445 0.449,8.448 0.496,8.448 V 8.322 H 0.495 C 0.446,8.322 0.404,8.32 0.367,8.316 Z M 0.678,8.311 V 8.438 C 0.73,8.431 0.773,8.421 0.807,8.41 V 8.296 C 0.8,8.294 0.793,8.292 0.786,8.29 0.758,8.298 0.723,8.306 0.678,8.311 Z M 0.212,8.296 V 8.41 C 0.246,8.421 0.289,8.431 0.341,8.438 V 8.313 C 0.295,8.307 0.259,8.299 0.231,8.29 0.224,8.292 0.218,8.294 0.212,8.296 Z M 0.833,8.4 C 0.87,8.385 0.89,8.368 0.89,8.353 0.89,8.338 0.87,8.321 0.833,8.306 Z M 0.128,8.353 c 0,0.015 0.02,0.032 0.057,0.047 V 8.306 C 0.148,8.321 0.128,8.338 0.128,8.353 Z M 0.833,8.274 V 8.277 C 0.856,8.286 0.876,8.296 0.89,8.308 V 8.248 C 0.877,8.253 0.86,8.263 0.833,8.274 Z M 0.128,8.308 C 0.142,8.296 0.162,8.286 0.185,8.277 V 8.274 C 0.158,8.263 0.14,8.252 0.128,8.248 Z",
    clipRule: "nonzero",
    id: "path98"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)",
    id: "g103"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12.628,
    y: -2.9200001,
    width: 19.549999,
    height: 13.831,
    style: {
      fill: "url(#_Linear6)"
    },
    id: "rect101"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(40.5381,0,0,-40.5381,178.425,723.598)",
    id: "g114"
  }, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.5,10.691 c 0,0 -0.001,0 -0.001,0 0,0 0,-0.001 -0.001,-0.001 C 0.456,10.688 0.474,10.632 0.452,10.623 0.43,10.615 0,10.317 0,10.207 c 0,-0.024 0.006,-0.062 0.015,-0.092 0,0.047 0.009,0.078 0.027,0.09 0.04,0.026 0.163,0.082 0.458,0.084 0.295,-0.002 0.418,-0.058 0.458,-0.084 0.018,-0.012 0.027,-0.043 0.027,-0.09 0.009,0.03 0.015,0.068 0.015,0.092 0,0.11 -0.43,0.408 -0.453,0.416 -0.021,0.009 -0.003,0.065 -0.045,0.067 -0.001,0 -0.001,0.001 -0.001,0.001 0,0 -0.001,0 -0.001,0 z",
    clipRule: "nonzero",
    id: "path107"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)",
    id: "g112"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -13.432,
    y: -2.1370001,
    width: 20.746,
    height: 14.678,
    style: {
      fill: "url(#_Linear8)"
    },
    id: "rect110"
  })))))), /*#__PURE__*/React.createElement("defs", {
    id: "defs142"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,5.82916)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(210,34,58)",
      stopOpacity: 1
    },
    id: "stop122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(184,40,47)",
      stopOpacity: 1
    },
    id: "stop124"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,3.98378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(210,34,58)",
      stopOpacity: 1
    },
    id: "stop127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(184,40,47)",
      stopOpacity: 1
    },
    id: "stop129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,7.99028)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(210,34,58)",
      stopOpacity: 1
    },
    id: "stop132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(184,40,47)",
      stopOpacity: 1
    },
    id: "stop134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,10.4027)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(210,34,58)",
      stopOpacity: 1
    },
    id: "stop137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(184,40,47)",
      stopOpacity: 1
    },
    id: "stop139"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsLogo);
export default __webpack_public_path__ + "static/media/gs-logo.3c5fb67e1e7d959fc854c00685735f0d.svg";
export { ForwardRef as ReactComponent };